import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-features-main-card',
  templateUrl: './features-main-card.component.html',
  styleUrls: [
    './styles/features-main-card.component.scss',
    './styles/features-main-card-tablet.scss',
    './styles/features-main-card-mobile.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturesMainCardComponent {

  @Input() public title: string = '';
  @Input() public icon: string = '';
  @Input() public mainColor: string = '';
  @Input() public img: string = '';
  @Input() public imgMob: string = '';
  @Input() public imgAlt: string = '';
  @Input() public buttonLink: string = '';
  @Input() public priorityImg: boolean = false;
  @Input() public badge: string = '';

}
